import { REQUEST_EXISTANT_CLAIMS_FOR_LAWYER } from 'containers/LawyerDocumentsPage/constants';

export const requestExistantClaimsForLawter = (status: string) => ({
  type: REQUEST_EXISTANT_CLAIMS_FOR_LAWYER,
  status,
});
